<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->

<div
  class="main_wp enq_listing pikdrop_enq enq_dtl_card sp_tracking successMessage ride-completed-mdl">
  @if (enquiry()) {
    <div class="s_head">
      <h2>
        {{
          enquiry()?.is_arrived_end === true
            ? ('RideInCompleted' | translate)
            : ('RideCompleted' | translate)
        }}
        <span class="c_primary"> ({{ 'Paid' | translate }})</span>
      </h2>
    </div>
    <div class="conta_iner sp_auctions_bids">
      <ul class="enq_lst_cards new_sp_list">
        <li class="px-0">
          <div class="top_row">
            <div class="lts">
              <figure>
                <img
                  [src]="enquiry().user_details.photo || assetsConst.account"
                  alt="dp" />
              </figure>
              <h5>
                {{ enquiry().user_name }}
                <span class="d_block">{{
                  enquiry().user_details.gender | titlecase | translate
                }}</span>
              </h5>
            </div>
          </div>

          <div class="loc_point">
            <ul>
              @if (
                enquiry() &&
                enquiry().locations &&
                enquiry().locations.length > 0
              ) {
                @for (
                  list of enquiry().locations;
                  track list;
                  let index = $index
                ) {
                  <li
                    [style.--flagImg]="'url(' + list.flag + ')'"
                    class="isCompleted"
                    [ngClass]="{
                      schedule: enquiry().schedule_type === 'SCHEDULE',
                    }">
                    <div class="lt">
                      <p class="primary">
                        @if (enquiry().module_id === 'RENTAL') {
                          {{ 'LocationAddress' | translate }}
                        } @else {
                          {{
                            index === 0
                              ? ('Pickup' | translate)
                              : ('DropOff' | translate)
                          }}
                          @if (index > 0 && enquiry().locations.length > 2) {
                            {{ index }}
                          }
                        }

                        <span>
                          {{ list.address }}
                        </span>
                      </p>
                      <h6>
                        <bdi>
                          {{ arrayDates()[index].date }}
                        </bdi>
                        <span class="d_block">
                          <bdi>
                            {{ arrayDates()[index].time }}
                          </bdi>
                        </span>
                      </h6>
                    </div>
                  </li>
                }
              }
            </ul>
          </div>
        </li>
      </ul>
    </div>
    <div class="price_footer">
      @if (charge() > 0 && totalWaiting() > 0) {
        <p class="price">
          <span>{{ 'tripFare' | translate }}</span>
          <ins
            >{{ user.currency_code }}
            {{ charge() | number: '1.3-3' }}
          </ins>
        </p>
      }

      @if (totalWaiting() > 0) {
        <p class="price">
          <span>{{ 'WaitingChargesApplied' | translate }}</span>
          <ins
            >{{ user.currency_code }}
            {{ totalWaiting() | number: '1.3-3' }}
          </ins>
        </p>
      }

      <p class="price total">
        <span>{{ 'totalAmount' | translate }}</span>
        <ins
          >{{ user.currency_code }}
          {{ displayedTotalAmount() | number: '1.3-3' }}
        </ins>
      </p>
    </div>
  }
  <ngx-ui-loader
    loaderId="uniqueLoader1"
    overlayColor="rgba(255,255,255,0.8)"
    blur="13"
    fgsType="circle"
    fgsColor="#000"
    [hasProgressBar]="false" />
</div>
@if (enquiry()) {
  <div class="btn_full btn_accept site_btn mb-0" (click)="btn_route()">
    <p-button
      class="btn primary"
      type="button"
      label="{{ 'BackToHome' | translate }}" />
  </div>
}
